import React from 'react';
import TagMoveButtons from './TagMoveButtons';
import TagDeleteButton from './TagDeleteButton';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';

type TagEditContentProps = { tag: Tag; shareRootPath: ImMNElement[]; closePopup: () => void };

const TagEditContent: React.FC<TagEditContentProps> = (props) => {
    const { tag, closePopup, shareRootPath } = props;

    if (!tag) return null;

    return (
        <div className="MobileTagEditContent">
            <TagMoveButtons tag={tag} shareRootPath={shareRootPath} />
            <TagDeleteButton tag={tag} closePopup={closePopup} />
        </div>
    );
};

export default TagEditContent;
